import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { SystemsService } from '@app/core/services/systems.service';
import { UnsavedChangesDialogComponent } from '@app/dashboard/deals/components/unsaved-changes-dialog/unsaved-changes-dialog.component';
import { Transaction } from '../transaction';
import { TransactionPrivate } from '@app/core/resources/transaction-private';
import { System } from '@app/core/resources/system';
import { Injectable } from '@angular/core';
import TransactionAmountCalculator from '../transaction-amount-calculator';

@Injectable({
    providedIn: 'root'
})
export class MessageAlertQuotationHelper {
    public transaction!: Transaction | TransactionPrivate;

    public constructor(public transferState: TransferState, public systemsService: SystemsService, public matDialog: MatDialog) {}

    private recalculate(): void {
        let system1: System | null | undefined = this.transaction.relationships.system1.data;
        let system2: System | null | undefined = this.transaction.relationships.system2.data;
        if (!system1 || !system2) {
            return;
        }

        let transactionAmountCalculator: TransactionAmountCalculator = new TransactionAmountCalculator();
        if (this.transaction.attributes.__operation === 'send') {
            this.transaction.attributes.amount1 = transactionAmountCalculator.getSendAmount(
                system1,
                system2,
                this.transaction.attributes.amount2
            );
        } else if (this.transaction.attributes.__operation === 'receive') {
            this.transaction.attributes.amount2 = transactionAmountCalculator.getReceiveAmount(
                system2,
                system1,
                this.transaction.attributes.amount1
            );
        }
    }

    public openDialog(message: string): void {
        let dialog: MatDialogRef<UnsavedChangesDialogComponent> = this.matDialog.open(UnsavedChangesDialogComponent, {
            width: '600px',
            autoFocus: false,
            data: {
                text: message,
                updateDeals: 'Aceptar'
            }
        });

        dialog.afterClosed().subscribe((): void => {
            /* eslint-disable @typescript-eslint/dot-notation */
            Object.keys(this.transferState['store']).forEach((key: string): void => this.transferState.remove(makeStateKey(key)));
            /* eslint-enable @typescript-eslint/dot-notation */
            this.systemsService.all({ include: ['rates'] }).subscribe(() => {
                this.recalculate();
            });
        });
    }
}
